
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"9","fill":"#AFE9B0"}}),_c('path',{attrs:{"d":"M16.863 8.84c-.893-.365-2.668-1.153-5.065-.707-2.284.425-3.263 2.863-3.588 3.939l-.017.06a.447.447 0 01-.123.216c-.86.823-1.462 1.827-1.569 3.042a.42.42 0 00.288.434l.462.155a.424.424 0 00.557-.384c.029-.683.243-1.314.646-1.907a.227.227 0 01.316-.059l.002.001c1.02.678 3.094 1.671 5.258.275 2.049-1.321 2.858-3.128 3.256-4.004.346-.763.142-.831-.423-1.062z","fill":"#008009"}})])
          )
        }
      }
    